@import 'core';

/**
 * @prop --ads-masthead-background-color: Background color
 * @prop --ads-masthead-border-bottom-color: Border bottom color
 * @prop --ads-masthead-color: Text color
 * @prop --ads-masthead-horizontal-padding: Horizontal padding
 * @prop --ads-masthead-text-align: Text alignment
 */

::slotted(*) {
  box-sizing: border-box;
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
}

::slotted([slot='heading']) {
  color: var(--ads-masthead-color, $ads-masthead-color) !important;
  justify-content: inherit;
  line-height: 1.25em !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host {
  background-color: var(--ads-masthead-background-color, $ads-masthead-background-color);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  position: relative;
  width: 100%;
}

:host([theme='default']) {
  @include ads-vars-component-masthead-default;
}

:host([theme='dark']) {
  @include ads-vars-component-masthead-dark;
}

:host([theme='light']) {
  @include ads-vars-component-masthead-light;
}

:host([dir='ltr']) {
  @include ads-vars-component-masthead-ltr;
}

:host([dir='rtl']) {
  @include ads-vars-component-masthead-rtl;
}

.c-masthead {
  align-items: flex-start;
  border: 0;
  border-bottom: 1px solid var(--ads-masthead-border-bottom-color, $ads-masthead-border-bottom-color);
  box-sizing: border-box;
  display: flex !important;
  flex-direction: column;
  font-family: var(--ads-font-family);
  justify-content: center;
  min-height: 90px;
  padding: 0 var(--ads-masthead-horizontal-padding, $ads-masthead-horizontal-padding);
  position: relative;

  @include media-query(md-up) {
    justify-content: flex-start;
    min-height: 105px;
    padding: 0 calc(var(--ads-masthead-horizontal-padding, $ads-masthead-horizontal-padding) * 2);
  }

  &__top {
    display: flex !important;
    margin: 0;
    max-height: 30px;

    @include media-query(md-up) {
      flex-direction: row;
      position: absolute;
      top: 10px;
      width: calc(100% - 32px);
    }
  }

  &__heading {
    margin: 0;
    width: calc(100% - 32px);

    @include media-query(md-up) {
      padding-top: 4px;
      position: absolute;
      text-align: var(--ads-masthead-text-align, $ads-masthead-text-align-ltr);
      top: 30px;
    }
  }
}
